import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M4 15l4-5-4-5v10zM7 5h9v1H7V5zm0 9h9v1H7v-1zm3-3h6v1h-6v-1zm0-3h6v1h-6V8z'],
  height: 20,
  width: 20,
});
